import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import GameContext, { Sounds } from '../../context/GameContext';
import intros from './intros';
import { getWorldTitle, ModeRouteParams } from '../mode/Mode';
import logos from '../../media/logos-flag.png';
import introCounterBackground from '../../media/intro-counter-background.png';
import Character from '../../components/character/Character';
import multipleOptionBack from '../../media/multiple-option-back.png';
import introButtonStart from '../../media/intro-button-start.png';
import Information from '../../components/common/Information';

interface IntroProps {}

const Intro: FunctionComponent<IntroProps> = () => {
    const history = useHistory();
    const routerParams = useParams<ModeRouteParams>();

    const { playerName, handleMainSound } = useContext(GameContext);

    const [isAudioCompleted, setIsAudioCompleted] = useState(false);

    const [count, setCount] = useState(3);
    const [currentBackgroundImageIndex, setCurrentBackgroundImageIndex] = useState(0);

    const handleGoBack = () => {
        history.goBack();
    };

    const handleGoToQuestionnaire = () => {
        history.push(`${process.env.PUBLIC_URL}/questionnaire/${routerParams.worldId}`);
    };

    const startAudioDurationTimer = (duration: number) => {
        setTimeout(() => {
            setIsAudioCompleted(true);
        }, duration);
    };

    useEffect(() => {
        if (count > 0) {
            setTimeout(() => setCount(count - 1), 1000);
        }
    }, [count]);

    useEffect(() => {
        if (count === 0) {
            const nextBackgroundImageIndex =
                currentBackgroundImageIndex + 1 === intros[routerParams.worldId].images.length
                    ? 0
                    : currentBackgroundImageIndex + 1;

            setTimeout(() => setCurrentBackgroundImageIndex(nextBackgroundImageIndex), 4000);
        }
    }, [currentBackgroundImageIndex, setCurrentBackgroundImageIndex, count, routerParams.worldId]);

    useEffect(() => {
        handleMainSound(`play-${routerParams.worldId}-intro` as Sounds);
        startAudioDurationTimer(intros[routerParams.worldId].audioDuration);

        return () => handleMainSound(`stop-${routerParams.worldId}-intro` as Sounds);
    }, [handleMainSound, routerParams.worldId]);

    return (
        <>
            <div
                className="page-container page-intro animate__animated animate__fadeIn"
                style={{
                    backgroundImage:
                        currentBackgroundImageIndex > 0
                            ? `url(${intros[routerParams.worldId].images[currentBackgroundImageIndex]})`
                            : undefined,
                }}
            >
                {intros[routerParams.worldId].copyright && (
                    <div className="intro-copyright">
                        Fotografía: {intros[routerParams.worldId].copyright![currentBackgroundImageIndex]}
                    </div>
                )}
                {count === 0 && (
                    <div>
                        {intros[routerParams.worldId].images.map((image, index) => (
                            <div
                                key={index}
                                style={{ backgroundImage: `url(${image})` }}
                                className={`intro-image animate__animated ${
                                    currentBackgroundImageIndex === index ? 'animate__fadeIn' : 'animate__fadeOut'
                                }`}
                            />
                        ))}
                        <div
                            className="intro-image intro-overlay"
                            style={{
                                opacity: isAudioCompleted ? 0.5 : 0,
                            }}
                        ></div>
                    </div>
                )}
                <img
                    src={getWorldTitle(routerParams)}
                    className="world-logo animate__animated animate__backInLeft"
                    alt="¡Bienvenido/a a la Cuenca!"
                />
                <img
                    src={logos}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <div className="intro-counter">
                    {isAudioCompleted && (
                        <div className="intro-counter-background-container">
                            <img src={introCounterBackground} alt="¡Empezamos!" className="intro-counter-background" />
                        </div>
                    )}
                    <div
                        className={`count-text ${
                            count === 0 ? 'finished' : 'animate__animated animate__infinite animate__rubberBand'
                        }`}
                    >
                        {count > 0
                            ? count
                            : isAudioCompleted && (
                                  <div className="animate__animated animate__rubberBand">
                                      <img
                                          src={introButtonStart}
                                          alt="¡Empezar!"
                                          className="intro-button-start animate__animated animate__pulse animate__infinite"
                                          onClick={handleGoToQuestionnaire}
                                      />
                                  </div>
                              )}
                    </div>
                </div>
                <div className="game-menu">
                    <div className="character-mini-container animate__animated animate__bounceIn">
                        <Character name={playerName} />
                    </div>
                    <img
                        src={multipleOptionBack}
                        className="game-menu-button-back animate__animated animate__backInUp"
                        alt="Regresar"
                        onClick={handleGoBack}
                    />
                </div>
            </div>
            <Information helpText='Escucha atentamente esta divertida introducción a la Cuenca mientras observas fotografías que te darán pistas para aprender más, una vez termine la introducción, por favor haz clic en el botón "Empezar" para iniciar la partida de juego.' />
        </>
    );
};

export default Intro;
